// import './App.css';
// import Navbar from './components/navbar/navbar';
// import { BrowserRouter, Routes, Route } from 'react-router-dom'
// import Home from './pages/home';
// import ShopCategory from './pages/shopCategory';
// import Product from './pages/product';
// import Cart from './pages/cart';
// import LoginSignup from './pages/loginSignup';
// import Footer from './components/footer/footer'
// import Favourites from './pages/favourites';
// import CheckoutSuccess from './pages/checkoutSuccess'
// import Account from './pages/account'

// function App() {
//   return (
//     <div className="App">
//       <BrowserRouter>
//         <Navbar />
//         <Routes>
//           <Route path='/favourites' element={<Favourites />} />
//           <Route path='/' element={<Home />} />
//           <Route path='/wedding' element={<ShopCategory category='wedding' />} />
//           <Route path='/birthday' element={<ShopCategory category='birthday' />} />
//           <Route path='/engagement' element={<ShopCategory  category='engagement' />} />
//           <Route path='/all' element={<ShopCategory  category='all' />} />

//           <Route path='/card/:productId' element={<Product />} />
//           <Route path='/cart' element={<Cart />} />
//           <Route path='/order-confirmation' element={<CheckoutSuccess />} />
//           <Route path='/login' element={<LoginSignup />} />
//           <Route path='/account' element={<Account />} />


//         </Routes>
//         <Footer />
//       </BrowserRouter>
//     </div>
//   );
// }

// export default App;

import './App.css';
import Navbar from './components/navbar/navbar';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/home';
import ShopCategory from './pages/shopCategory';
import Product from './pages/product';
import Cart from './pages/cart';
import LoginSignup from './pages/loginSignup';
import Footer from './components/footer/footer';
import Favourites from './pages/favourites';
import CheckoutSuccess from './pages/checkoutSuccess';
import Account from './pages/account';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <BrowserRouter>
      <MainApp />
    </BrowserRouter>
  );
}

function MainApp() {
  const location = useLocation();

  // Define the pages where you don't want to show the footer
  const hideFooterPaths = ['/order-confirmation', '/account'];

  // Check if the current path is one of those where the footer should be hidden
  const shouldHideFooter = hideFooterPaths.includes(location.pathname);

  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path='/favourites' element={<Favourites />} />
        <Route path='/' element={<Home />} />
        <Route path='/wedding' element={<ShopCategory category='wedding' />} />
        <Route path='/birthday' element={<ShopCategory category='birthday' />} />
        <Route path='/engagement' element={<ShopCategory category='engagement' />} />
        <Route path='/all' element={<ShopCategory category='all' />} />
        <Route path='/card/:productId' element={<Product />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/order-confirmation' element={<CheckoutSuccess />} />
        <Route path='/login' element={<LoginSignup />} />
        <Route path='/account' element={<Account />} />
      </Routes>

      {/* Conditionally render the Footer */}
      {!shouldHideFooter && <Footer />}

      <ToastContainer position="top-center" autoClose={5000} />
    </div>
  );
}

export default App;
